import React, {useEffect, useState} from "react";
import {APIv1} from "../../../../../../api";
import {extractStringDateWithSeconds} from "../../../../../../utils";
import "./CardDetailSection.css";

const CardDetailSection = ({companyInn, marketId, userToken}) => {
    const [inactiveDevicesList, setInactiveDevicesList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchInactiveDevices = async () => {
            setLoading(true);
            try {
                let companyUrl = `/analysis/company/device/inactivity/${companyInn}`
                let marketUrl = `/analysis/market/device/inactivity/${marketId}`
                let url = companyInn ? companyUrl : marketUrl
                const res = await APIv1.get(url, {
                    headers: {
                        Authorization: `Token ${userToken}`,
                    }
                });
                setInactiveDevicesList(res.data);
            } catch (err) {
                setError("Failed to load device data.");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchInactiveDevices();
    }, [companyInn, marketId, userToken]);

    return (
        <div className="right-detail-section">
            <div className="table-header">
                <span>Device</span>
                <span>Fbox Ver.</span>
                <span>Order not sent</span>
                <span>Z-Report</span>
                <span>Upd date</span>
            </div>

            {loading && <div className="table-row">Loading...</div>}
            {error && <div className="table-row">{error}</div>}

            {!loading && !error && inactiveDevicesList.map((item, idx) => (
                <div className="table-row" key={idx}>
                    <span className="device-cell">{item.serial_number ?? "--------"}</span>
                    <span>{item.fbox_version === 'v1' ? 'POS' : 'SCO' ?? "--------"}</span>
                    <span>{Number(item.order_not_sent_count) ?? "--"}</span>
                    <span>{item.z_report_left_count ?? "--"}</span>
                    <span>{extractStringDateWithSeconds(item.last_updated_data) ?? "---. -, ----"}</span>
                </div>
            ))}
        </div>
    );
};

export default CardDetailSection;
